var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUpload = function SvgIconUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none",
    className: "IconUpload_svg__icon-upload"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.555 15.556c-1.948 0-3.526-1.329-3.526-3.276a3.527 3.527 0 0 1 3.918-3.505v-.022h.048a6.27 6.27 0 0 1 11.685-3.86q.395-.057.806-.058a5.486 5.486 0 0 1 5.485 5.485c0 2.494-1.664 4.396-3.942 5.022M11.827 20.3v-9m0 0-3.598 3.712m3.598-3.712 3.602 3.712"
  })));
};
export default SvgIconUpload;